import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProviderPaymentCalendar } from '../../features/providers/components/ProviderPaymentCalendar';

export const ProviderPaymentCalendarPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container paddingY={5} justifyContent={'center'}>
				<Grid item xs={12} sx={{ ml: 20 }}>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Calendario de pagos a proveedores
					</Typography>
				</Grid>

				<Grid item xs={12} paddingY={4} sx={{ px: 4 }}>
					<ProviderPaymentCalendar />
				</Grid>
			</Grid>
		</Layout>
	);
};
